var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavouritesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 4.59511C10.9109 3.59321 9.48468 3.03716 8.00447 3.03711C7.22101 3.03793 6.44544 3.19367 5.72241 3.49538C4.99937 3.79709 4.34313 4.2388 3.79147 4.79511C1.43847 7.15811 1.43947 10.8541 3.79347 13.2071L11.1255 20.5391C11.2955 20.8381 11.6235 21.0311 12.0005 21.0311C12.1553 21.0296 12.3076 20.9918 12.4451 20.9208C12.5827 20.8498 12.7016 20.7475 12.7925 20.6221L20.2075 13.2071C22.5615 10.8531 22.5615 7.15811 20.2055 4.79111C19.6541 4.23583 18.9984 3.79501 18.276 3.49399C17.5537 3.19298 16.779 3.03771 15.9965 3.03711C14.5163 3.03735 13.0902 3.59338 12.0005 4.59511ZM18.7915 6.20511C20.3545 7.77611 20.3555 10.2301 18.7935 11.7931L12.0005 18.5861L5.20747 11.7931C3.64547 10.2301 3.64647 7.77611 5.20547 6.20911C5.96547 5.45311 6.95947 5.03711 8.00447 5.03711C9.04947 5.03711 10.0395 5.45311 10.7935 6.20711L11.2935 6.70711C11.3863 6.80006 11.4965 6.87379 11.6178 6.9241C11.7391 6.97441 11.8691 7.00031 12.0005 7.00031C12.1318 7.00031 12.2618 6.97441 12.3832 6.9241C12.5045 6.87379 12.6147 6.80006 12.7075 6.70711L13.2075 6.20711C14.7195 4.69811 17.2815 4.70211 18.7915 6.20511Z",
    fill: "#1478FF",
    stroke: "#1478FF",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouritesIcon);
export default __webpack_public_path__ + "static/media/favourites-icon.84dffb26ff5c73bf8ac824e6a5c5c8eb.svg";
export { ForwardRef as ReactComponent };